type DICT_ENUM = {
    [key: string]: string
}

export const OperateType:DICT_ENUM = {
    Add: 'Add',
    Modify: 'Modify'
}

export const ClueTypeZh:DICT_ENUM = {
    '01': '新增部门',
    '02': '撤销新增',
    '03': '修改部门失效时间',
    '04': '部门信息变更',
    '05': '合并部门',
    '06': '撤销合并',
    '07': '拆分部门',
    '08': '撤销拆分'
}

export const ClueStatusZh:DICT_ENUM = {
    '0': '未发送',
    '1': '已发送'
}

export const OrgStatusZh:DICT_ENUM = {
    '0': '已失效',
    '1': '生效中',
    '2': '待生效'
}

// 发布状态
export const ReleaseStatus:DICT_ENUM = {
    Published: '1',
    UnPublished: '0'
}

export const OrgStatus:DICT_ENUM = {
    Expired: '0',
    InEffect: '1',
    ToBeEffect: '2'
}

export const ClueType:DICT_ENUM = {
    AddDept: '01', // 新增部门
    RevokeAddition: '02', // 撤销新增
    ModDeptExpirat: '03', // 修改部门失效时间
    DeptInfoChange: '04', // 部门信息变更
    MergeDept: '05',  // 合并部门
    RevokeMergeDept: '06', // 撤销合并
    SplitDept: '07', // 拆分部门
    RevokeSplitDept: '08' // 撤销拆分
}

export const readOptionsFromEnumZh = (enumZh:DICT_ENUM) => {
    return Object.entries(enumZh).map(entry => {
        const [key, value] = entry
        return {
            label: value,
            value: key
        }
    })
}

export const MessageCode:DICT_ENUM = {
    Success: "100"
}